export default function InviteService($http, appSettings) {
  'ngInject';
  this.postInvite = function (email, data) {
    var endpoint = appSettings.IcebergApiUserInfoEndpoint + '/invites/email/' + email;
    return $http.post(endpoint, data);
  };
}